import React from "react";
var __jsx = React.createElement;
import Lottie from "lottie-react";
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import { BottomSheet } from "@/components/ui/bottom-sheet";
import warningAnimation from "@/pages/split-payment/assests/tryOther.json";
/**
 * Cancel-application confirmation shared by the BNPL flows, built on the
 * split-payment `CancelProgressBottomSheet` pattern: shared `BottomSheet`
 * chrome (bottom sheet on mobile, centered modal on desktop), Lottie warning
 * art, stacked CTAs. No dedicated cancel Pop-Up exists in the Figma desktop
 * frames, so the split-payment confirmation is the design reference.
 */
var BNPLCancelPopup = function BNPLCancelPopup(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(["web_tracking", "web_checkout_finance"]),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(BottomSheet, {
    open: show,
    onClose: onClose,
    showCloseButton: !isMobile,
    title: t("sure_cancel_application", {
      ns: "web_tracking"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-3 px-6 pb-8 pt-6 text-center"
  }, /*#__PURE__*/React.createElement(Lottie, {
    animationData: warningAnimation,
    loop: false,
    className: "h-24 w-24"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "m-0 text-lg font-bold text-[#00143c]"
  }, t("sure_cancel_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "m-0 text-sm text-[#8a94a6]"
  }, t("information_saved_need_refill_data", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onConfirm,
    className: "mt-4 w-full cursor-pointer rounded-lg border-none bg-primary-new py-3 text-base font-bold text-white transition-colors hover:bg-primary-120"
  }, t("continue_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onCancel,
    className: "cursor-pointer border-none bg-transparent py-2 text-base font-bold text-[#e5231f]"
  }, t("cancel_submitting_application", {
    ns: "web_tracking"
  }))));
};
export default BNPLCancelPopup;